import { put, takeLatest } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import { fetchlimitationSuccess , fetchlimitationFailure  } from '../actions';
import LimitationTypes from '../types';


const { API_BASE_URL } = urls || {};

function* fetchlimitations({data}) {
  const {orgId} = data
  const url = `${API_BASE_URL}/subscriptions/${orgId}`;
  const response = yield request({
    method: 'get',
    url,
  });

  if (response.success) {
    yield put(fetchlimitationSuccess(response?.raw));

  } else {
    yield put(fetchlimitationFailure('An error occured. Please reload the page to try again.'));

  }
}


export function* onGetLimitation() {
  yield takeLatest(
    LimitationTypes.FETCH_LIMITATION_START,
    fetchlimitations
  );
}
